import { applicationApi } from "../../common/api";
import { CreateOfficeLocation, OfficeLocation } from "./types";

// Define a service using a base URL and expected endpoints
export const officelocationApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllOfficeLocation: builder.query<OfficeLocation[], void>({
      query: () => `contact/office`,
      providesTags: [{ type: "OfficeLocation", id: "LIST" }],
    }),
    getOfficeLocation: builder.query<OfficeLocation, string>({
      query: (query) => `contact/office/${query}`,
    }),
    createOfficeLocation: builder.mutation<OfficeLocation, any>({
      query: (body) => ({
        url: "/contact/office",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "OfficeLocation", id: "LIST" }],
    }),
    deleteOfficeLocation: builder.mutation<any, number>({
      query: (id) => ({
        url: `contact/office/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "OfficeLocation", id: "LIST" }],
    }),
    updateOfficeLocation: builder.mutation<OfficeLocation, any>({
      query: (body) => ({
        url: `/contact/office/${body.id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "OfficeLocation", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllOfficeLocationQuery,
  useGetOfficeLocationQuery,
  useCreateOfficeLocationMutation,
  useDeleteOfficeLocationMutation,
  useUpdateOfficeLocationMutation,
} = officelocationApi;
